import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from 'components/Dialog';
import Modal from 'react-bootstrap/lib/Modal'; 
import Button from 'react-bootstrap/lib/Button';
import UploadFileDialog from 'components/UploadFileDialog';
import * as actions from 'modules/files';
import {injectIntl} from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const pictureTooltip = (
    <Tooltip id="pictureTooltip">
        Click to select this picture.
    </Tooltip>
);

class SelectPhotoDialog extends Dialog {

    constructor(props) {
        super(props);

        this.uploadFile = this.uploadFile.bind(this);
        this.showUploadFileDialog = this.showUploadFileDialog.bind(this);        
    }

    componentDidMount() {
        const {dispatch} = this.props;
        let websiteId = this.props.websiteId;
        dispatch(actions.fetchFiles(websiteId));
    }


    uploadFile(data){
        const {dispatch} = this.props;
        
        let websiteId = this.props.websiteId;
        dispatch(actions.uploadFile(data.file, websiteId));
    }

    removeFile(id){
        const {dispatch, websiteId} = this.props;

        dispatch(actions.removeFile(id, websiteId));
    }

    showUploadFileDialog(){
        this.uploadFileDialog.wrappedInstance.show();
    }

    select(photo){
        const {onOk} = this.props;

        onOk(photo);
        this.hide();
    }

    render() {
        let websiteId = this.props.websiteId;
        let { photos, handleSubmit, dialogTitle, closeButtonLabel, submitButtonLabel, submitting, uploadFailed, intl } = this.props;
        
        let show =  this.state.show;
        let k= 0;

        return (

            <Modal backdrop="static" enforceFocus={true} show={show || false} onHide={this.hide}>

                    <Modal.Header closeButton>
                        <Modal.Title>{intl.formatMessage({id: 'selectPhotoDialog.title'})}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    {photos.length >0 && <small><label>{intl.formatMessage({id: 'selectPhotoDialog.clickToSelect'})}</label><br/><br/></small>}
                        {
                            photos.length === 0? <div>{intl.formatMessage({id: 'selectPhotoDialog.noPhoto'})}</div> :
                            photos.map((photo) => {
                                return <div style={{display: 'inline'}} key={'ph' + k++}>
                                    <OverlayTrigger placement="right" overlay={pictureTooltip}>
                                        <img title="Click on this photo to set it as logo" key={'ph' + k++} onClick={this.select.bind(this, photo)} className="gallery-photo" alt={photo.metadata.fileId} src={'/file/' + websiteId + '/' + photo._id}></img>
                                    </OverlayTrigger>
                                    
                                    <i className="fa fa-minus-circle widget-delete-item" title="Remove Picture" onClick={this.removeFile.bind(this, photo._id)}></i>
                                </div>
                            })

                        }
                        <br /><br />
                        <button className="btn btn-success btn-sm" onClick={this.showUploadFileDialog}>{intl.formatMessage({id: 'selectPhotoDialog.upload'})}</button>
                         <UploadFileDialog ref={instance => {this.uploadFileDialog = instance}} onOk={this.uploadFile} 
                         dialogTitle={intl.formatMessage({id: 'selectPhotoDialog.add'})} 
                         closeButtonLabel={intl.formatMessage({id: 'selectPhotoDialog.close'})}
                         submitButtonLabel={intl.formatMessage({id: 'selectPhotoDialog.submit'})} />
                        {uploadFailed?  <span className="label label-danger">Upload failed. Maximum file size allowed is 250KB.</span>: ""}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.hide}>{closeButtonLabel}</Button>
                       
                    </Modal.Footer>
            </Modal>
        );
    }

}


SelectPhotoDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    photos: PropTypes.array.isRequired
}



function mapStateToProps(state) {
    return {
        photos: state.files.list, //todo filter by extension,
        uploadFailed: state.files.uploadFailed
    };
}


export default injectIntl(connect(mapStateToProps, null, null, {
    withRef: true
})(SelectPhotoDialog),{
    withRef: true
});



// WEBPACK FOOTER //
// app/containers/SelectPhotoDialog.jsx